/**
 * The backend's device ids, their labels and the lookup a cell uses.
 *
 * `deviceLabel(id)` for a value read off a record — it falls back to the id itself, so an
 * id the backend adds before this file learns about it still renders. For a form or a
 * filter, build the options from `DeviceLabels` with `idsToOptions` / `labelsToOptions`
 * rather than listing the devices again.
 */
export const Device = {
  Desktop: 1,
  Mobile: 2,
  Tablet: 3,
  Console: 4,
  TV: 5,
  Wearable: 6
} as const

export type DeviceId = (typeof Device)[keyof typeof Device]

export const DeviceLabels: Record<DeviceId, string> = {
  [Device.Desktop]: 'Desktop',
  [Device.Mobile]: 'Mobile',
  [Device.Tablet]: 'Tablet',
  [Device.Console]: 'Console',
  [Device.TV]: 'TV',
  [Device.Wearable]: 'Wearable'
} as const

export function deviceLabel(id: number): string {
  return DeviceLabels[id as DeviceId] ?? String(id)
}
